import React from "react";
import { useTranslation, getI18n } from "react-i18next";
import { Skeleton } from "antd";
import { CONSTANTS as C } from "config";
import { SVG_FOOD_AND_BEVARAGES, SVG_RETAIL } from "svg/SVGs";
import { API } from "api";

const getKeyAgainstLanguage = () => {
  const lang = getI18n();
  return lang.language == "en" ? C.KEY_CAT_INFO_EN : C.KEY_CAT_INFO_AR;
};

const HeadingWithIcon = ({ icon, title }) => {
  return (
    <div className="flex gap-2 items-center">
      {icon}
      <h3 className="font-bold text-start text-19px text-blue-600">{title}</h3>
    </div>
  );
};

const ServiceTypeItem = ({ value, name, onSelectCategory = () => {} }) => {
  return (
    <button
      onClick={() => {
        window?.scrollTo(0, 0);
        onSelectCategory(value);
      }}
      className="py-2 px-4 border border-theme-blue-light-2 rounded-full text-center cursor-pointer hover:bg-theme-blue-color hover:text-white transition-all duration-300"
    >
      {name}
    </button>
  );
};

const ServiceWithCategories = ({
  icon,
  title,
  categories,
  loading,
  categoryKey,
  onSelectCategory = () => {},
}) => {
  return (
    <div className="flex flex-col gap-4 my-2">
      <HeadingWithIcon icon={icon} title={title} />
      <Skeleton loading={loading} />
      <div className="flex flex-wrap gap-3">
        {categories?.length > 0 &&
          categories.map((category) => (
            <ServiceTypeItem
              key={category._id}
              value={category._id}
              name={category[getKeyAgainstLanguage()][categoryKey]}
              onSelectCategory={onSelectCategory}
            />
          ))}
      </div>
    </div>
  );
};

const CategoriesList = [
  {
    icon: <SVG_FOOD_AND_BEVARAGES />,
    title: "Food & Bevarages",
    categoryKey: C.KEY_CAT_TITLE,
    type: "F_AND_B",
  },
  {
    icon: <SVG_RETAIL />,
    title: "Retail",
    categoryKey: C.KEY_CAT_TITLE,
    type: "RETAIL",
  },
];

const Step1 = ({ onNextStep = () => {} }) => {
  const { t } = useTranslation();

  const [superCategories, setSuperCategories] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedCategory, setSelectedCategory] = React.useState({
    mainCategory:"",
    subCategory:"",
  });

  const getSuperCategories = async () => {
    const result = await API.getSuperCategories();
    if (result.success === 1) setSuperCategories(result.data);
    else return [];
    setLoading(false);
  };

  const onSelectCategory = (category) => {
    onNextStep("serviceType", category);
  };

  React.useEffect(() => {
    getSuperCategories();
  }, []);

  return (
    <div className="flex flex-col gap-4">
      {CategoriesList.map((item, index) => (
        <ServiceWithCategories
          key={"service-with-categories-" + index}
          icon={<div className="w-10 h-10">{item.icon}</div>}
          title={t(item.title)}
          categories={superCategories.filter(
            (category) => category.type === item.type
          )}
          loading={loading}
          categoryKey={item.categoryKey}
          onSelectCategory={onSelectCategory}
        />
      ))}
    </div>
  );
};

export default Step1;
